import { HTTPInstanceFastApiWithPrefix } from '@/lib/http/http-instance-fastapi-with-prefix'

type ChatHistoryItem = {
  role: 'user' | 'assistant'
  content: string
}

class ChatBotAPI {
  static postMessage = (
    message: string,
    history: ChatHistoryItem[],
    language: string
  ): Promise<string> =>
    HTTPInstanceFastApiWithPrefix.post('/query-instruction', {
      query: message,
      language: language.split('-')[0].toLowerCase(),
      history: history.slice(-6)
    }).then(response => response.data)
}

export default ChatBotAPI
